import { fetchQuery, graphql } from "relay-runtime"
import {
  insureeDataFromSasisByHealthInsuranceCardNumberQuery,
  insureeDataFromSasisByHealthInsuranceCardNumberQuery$data,
} from "@/modules/admin/sasis-lookup/services/__generated__/insureeDataFromSasisByHealthInsuranceCardNumberQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query insureeDataFromSasisByHealthInsuranceCardNumberQuery($healthInsuranceCardNumber: String!) {
    ch_insureeDataFromSasisByHealthInsuranceCardNumber(healthInsuranceCardNumber: $healthInsuranceCardNumber) {
      mapped {
        firstName
        lastName
        dateOfBirth
        gender
        insureeNumber
        insuranceCardNumber
        socialSecurityNumber
        healthInsurance
        nationalInsuranceNumber
        isPrimary
        gatekeeperZsr
        validFrom
        validTo
        address {
          houseNumberStreet
          city
          postalCode
          countryCode
        }
      }
      rawXml
      returnCode
      returnMessage
    }
  }
`

export type InsureeDataFromSasis =
  insureeDataFromSasisByHealthInsuranceCardNumberQuery$data["ch_insureeDataFromSasisByHealthInsuranceCardNumber"]

export const fetchInsureeDataFromSasisByHealthInsuranceCardNumber = (
  healthInsuranceCardNumber: string,
): Promise<InsureeDataFromSasis | null> =>
  fetchQuery<insureeDataFromSasisByHealthInsuranceCardNumberQuery>(
    RelayEnvironment,
    query,
    { healthInsuranceCardNumber },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => response?.ch_insureeDataFromSasisByHealthInsuranceCardNumber ?? null)
